export default __webpack_public_path__ + "static/media/oMpMQuBJnia6qXeC4tjabLl1X2K2.6a9b04fd.jpg";